import type { ProfileSectionItem } from "@bonusx-global/bx-design-system/dist/types/components/profile-sections/interfaces/profile-sections.interface";
import { useMemo } from "react";
import type { NavigateFunction } from "react-router-dom";
import type { ProfileSectionsById } from "../../../../api/features/profile/use-profile.query";
import { useIsIncomeAvailable } from "../../../../hooks/feature-flags/use-is-income-available/useIsIncomeAvailable";
import { useIsRealEstatesAvailable } from "../../../../hooks/feature-flags/use-is-real-estates-available/useIsRealEstatesAvailable";
import { buildSectionsFromBackend } from "./build-sections-from-backend";

interface UseProfileSectionsParams {
  navigate: NavigateFunction;
  sectionsById: ProfileSectionsById;
}

export function useProfileSections(params: UseProfileSectionsParams): ProfileSectionItem[] {
  const { navigate, sectionsById } = params;
  const isIncomeAvailable = useIsIncomeAvailable();
  const isRealEstatesAvailable = useIsRealEstatesAvailable();

  const sections = useMemo(
    function getProfileSectionsAndActiveStep() {
      return buildSectionsFromBackend({ sectionsById, navigate, isIncomeAvailable, isRealEstatesAvailable });
    },
    [navigate, sectionsById, isIncomeAvailable, isRealEstatesAvailable]
  );

  return sections;
}
